export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_f8039ed8-7fc2-40a1-8377-e00457ffcf87/artifacts/ilhoe6c9_IMG-20260618-WA0018%281%29.jpg";

export const HERO_FALLBACK =
    "https://images.unsplash.com/photo-1595248712807-2bb09673bfe0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

// Dark theme uses the white logo, light theme uses the black logo.
export const LOGO_DARK_THEME = "https://customer-assets-jai6qajn.emergentagent.net/job_rehealthme-launch/artifacts/8zv66wj7_RHM%20white.png";
export const LOGO_LIGHT_THEME = "https://customer-assets-jai6qajn.emergentagent.net/job_rehealthme-launch/artifacts/g499lt6l_RHM%20Black.png";

export const LIFESTYLE_BEDROOM =
    "https://static.prod-images.emergentagent.com/jobs/f8039ed8-7fc2-40a1-8377-e00457ffcf87/images/bceb57210741e7313f3e8060f4e8da0c86c8cc38476d472ac30dda7f7b677c0e.jpeg";

export const LIFESTYLE_RUN =
    "https://images.unsplash.com/photo-1744060204728-f68e434a3edf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const formatINR = (n) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);

export const packCopy = (p = {}) => {
    const type = `${p.product_type || ""} ${p.pack_size || ""}`.toLowerCase();
    const unit = type.includes("capsule")
        ? "CAPSULES"
        : type.includes("effervescent")
            ? "EFFERVESCENT TABLETS"
            : type.includes("tablet")
                ? "TABLETS"
                : p.unit_label
                    ? `${p.unit_label}S`.toUpperCase()
                    : "PACK";
    const digits = (p.pack_size || "").match(/\d+/);
    const count = digits ? digits[0] : (p.serving_count || null);
    const lines = (p.tagline || "")
        .split(/[.\u00b7]/)
        .map((x) => x.trim())
        .filter(Boolean)
        .slice(0, 3)
        .map((x) => `${x.toUpperCase()}.`);
    return { unit, count, lines };
};
